/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import AttorneySection from "../../../../../components/Sections/Divorce/DivorceAttorneySection/AttorneySection";
import IncorrectPenaltySection from "../../../../../components/Sections/Traffic/IncorrectPenaltySection/IncorrectPenaltySection";
import HowItWorksSection from "../../../../../components/Sections/Traffic/HowItWorksSection/HowItWorksSection";
import TrafficCheckin from "../../../../../components/Checkin/TrafficCheckin/TrafficCheckin";
import Container from "../../../../../components/Container/Container";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import TrafficCostRiskSection from "../../../../../components/Sections/Traffic/TrafficCostRiskSection/TrafficCostRiskSection";
import LpFineDrivingBanPartnerMeta from "./LpFineDrivingBanPartnerMeta";
import TrafficCheckinPartnerInsurer from "../../../../../components/Checkin/TrafficCheckin/TrafficCheckinPartnerInsurer";
import { trafficTeaserCards } from "../../../../../services/landingPageService";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";

const LpFineDrivingBanPartner = ({ partnerName }: { partnerName: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  // Partner config
  let hasInsurerCheckin;
  let partnerFullName;
  switch (partnerName) {
    case "wbs":
      partnerFullName = "WBS Rechtsanwälte";
      hasInsurerCheckin = false;
      break;
    case "arag":
      partnerFullName = "ARAG";
      hasInsurerCheckin = true;
      break;
    case "advocard":
      partnerFullName = "Advocard";
      hasInsurerCheckin = true;
      break;
    case "check24":
      partnerFullName = "CHECK24";
      hasInsurerCheckin = false;
      break;
    case "blitzereinspruch":
      partnerFullName = "Blitzereinspruch";
      hasInsurerCheckin = false;
      break;
    default:
      partnerFullName = "Partner";
      hasInsurerCheckin = false;
  }

  let switchChecking = (hasInsurerCheckin: boolean, partnerName: NonNullable<AbstractCase["partner"]>) => {
    if (hasInsurerCheckin) {
      return (
        <TrafficCheckinPartnerInsurer
          partner={partnerName}
          idPrefix={"top"}
          checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung! Was wird Ihnen vorgeworfen?"}
          accusation={{
            name: "accusation",
            detail: {
              name: "accusation",
              label: "Vorwurf auswählen",
              options: [
                { value: "speeding", label: "Geschwindigkeitsverstoß" },
                { value: "red_light", label: "Rotlichtverstoß" },
                { value: "distance", label: "Abstandsverstoß" },
                { value: "other", label: "Handy / Drogen / Parken / Sonstiges" },
              ],
            },
          }}
        />
      );
    }
    if (!hasInsurerCheckin) {
      return (
        <TrafficCheckin
          partner={partnerName}
          idPrefix={"top"}
          checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung! Was wird Ihnen vorgeworfen?"}
          accusation={{
            name: "accusation",
            detail: {
              name: "accusation",
              label: "Vorwurf auswählen",
              options: [
                { value: "speeding", label: "Geschwindigkeitsverstoß" },
                { value: "red_light", label: "Rotlichtverstoß" },
                { value: "distance", label: "Abstandsverstoß" },
                { value: "other", label: "Handy / Drogen / Parken / Sonstiges" },
              ],
            },
          }}
        />
      );
    }
  };

  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpFineDrivingBanPartnerMeta partnerFullName={partnerFullName} />
      <LandingPageTeaser
        headline={"Jetzt Einspruch einlegen!"}
        subheadline={"Effektiv gegen Bußgeld, Punkte oder Fahrverbot vorgehen"}
        teaserButtonText={"Kostenlose Ersteinschätzung"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection containerStyle={"settlementContainer"} partnerName={partnerName} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && <Container>{switchChecking(hasInsurerCheckin, partnerName)}</Container>}
        <IncorrectPenaltySection />
        <HowItWorksSection />
      </GreyBackgroundWrapper>
      <TrafficCostRiskSection />
      <GreyBackgroundWrapper>
        <AttorneySection
          product={"traffic"}
          textCards={false}
          subheading={"Sie möchten professionell und unkompliziert gegen Ihren Bescheid vorgehen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        />
        <AdvantagesLegalbirdAttorneySection product={"traffic"} />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && <Container>{switchChecking(hasInsurerCheckin, partnerName)}</Container>}
    </Layout>
  );
};

export default LpFineDrivingBanPartner;
